import axios, {AxiosInstance} from 'axios';

const globalAxios: AxiosInstance = axios.create({
    // Add default headers to help with CORS
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    // Ensure credentials are included for CORS requests
    withCredentials: false,  // Set to true if the API requires cookies
    timeout: 30000  // 30 second timeout
});

// Add request interceptor for debugging
globalAxios.interceptors.request.use(
    (config) => {
        console.log('🔵 Outbound Request:', {
            url: config.url,
            method: config.method,
            baseURL: config.baseURL,
            headers: {
                ...config.headers,
                Authorization: config.headers.Authorization ? '[Bearer token present]' : undefined
            },
            data: config.data
        });
        return config;
    },
    (error) => {
        console.error('🔴 Request Error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for debugging
globalAxios.interceptors.response.use(
    (response) => {
        console.log('🟢 Response:', {
            url: response.config.url,
            status: response.status,
            statusText: response.statusText,
            data: response.data
        });
        return response;
    },
    (error) => {
        if (error.response) {
            console.error('🔴 Response Error:', {
                url: error.config?.url,
                status: error.response.status,
                statusText: error.response.statusText,
                data: error.response.data
            });
        } else if (error.request) {
            console.error('🔴 No Response:', {
                url: error.config?.url,
                message: 'Request made but no response received'
            });
        } else {
            console.error('🔴 Setup Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default globalAxios;